import React, { useMemo } from 'react';
import Select, { components } from 'react-select';

/**
 * Custom wrapper around React-Select to match the new design of the app.
 *
 * TODO: Make that re-usable and use everywhere necessary. Also remove hardcoded styling values.
 */
const SearchDropdown = ({
  label,
  id,
  data,
  selectedUsers,
  optionDataFormatter,
  ...props
}) => {
  /**
   * A memoized variable that filters out selected users from the queried users.
   *
   * @param {Array} users - The array of users.
   * @param {Array} selectedUsers - The array of selected users.
   * @returns {Array} - The filtered array of users.
   */
  const options = useMemo(
    () =>
      data?.reduce((usersAcc, user) => {
        const userWasSelected = selectedUsers.some(
          (selectedUser) =>
            (selectedUser.id && user.id && selectedUser.id === user.id) ||
            (selectedUser._id && user._id && selectedUser._id === user._id)
        );

        if (!userWasSelected) {
          usersAcc.push(optionDataFormatter(user));
        }

        return usersAcc;
      }, []) || [],
    [data, selectedUsers]
  );

  return (
    <div className="flex flex-col pt-7">
      <label htmlFor={id} className="pb-1">
        {label}
      </label>
      <Select
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        id={id}
        closeMenuOnSelect
        options={options}
        styles={{
          control: (base) => ({
            ...base,
            borderRadius: 6,
            fontSize: 14,
            height: 44
          }),
          placeholder: (base) => ({
            ...base,
            color: '#B1B1B1'
          }),
          indicatorSeparator: (base) => ({
            ...base,
            display: 'none'
          })
        }}
        components={{
          Option: (props) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <components.Option {...props}>
              <div className="flex items-center">
                <img
                  className="w-10 mr-4 rounded-full"
                  src={props.data?.photo?.url || '/img/search/user.svg'}
                />
                {props.label}
              </div>
            </components.Option>
          )
        }}
      />
    </div>
  );
};

export default SearchDropdown;
